import api from '@/api'

// State（状態）
// https://next.vuex.vuejs.org/ja/guide/state.html
// 状態を監視するデータ
const state = () => ({
  data: {},
  query: {},
  inspection_type: {},
  selected_inspection_plan: {},
})

// Getters（算出プロパティ）
// https://next.vuex.vuejs.org/ja/guide/getters.html
// コンポーネントから状態を取得するプロパティまたは関数
const getters = {
  results: (state) => state.data.results,
  prev: (state) => state.data.previous,
  next: (state) => state.data.next,
  query: (state) => state.query,
  inspection_type: (state) => state.inspection_type,
  selected_inspection_plan: (state) => state.selected_inspection_plan,
}

// Mutations（状態変更）
// https://next.vuex.vuejs.org/ja/guide/mutations.html
// 状態を変更するメソッド
const mutations = {
  setData: (state, data) => (state.data = data),
  clearData: (state) => (state.data = {}),
  setQuery: (state, query) => (state.query = query),
  clearQuery: (state) => (state.query = {}),
  setInspectionType: (state, inspection_type) =>
    (state.inspection_type = inspection_type),
  clearInspectionType: (state) => (state.inspection_type = {}),
  setSelectedInspectionPlan: (state, inspection_plan) => (state.selected_inspection_plan = inspection_plan),
  clearSelectedInspectionPlan: (state) => (state.selected_inspection_plan = {}),
}

// Actions（処理）
// https://next.vuex.vuejs.org/ja/guide/actions.html
// コンポーネントからミューテーションを実行する関数
const actions = {
  clearAll({ commit }) {
    return new Promise((resolve) => {
      commit('clearData')
      commit('clearQuery')
      commit('clearInspectionType')
      commit('clearSelectedInspectionPlan')
      resolve()
    })
  },
  clearData({ commit }) {
    return new Promise((resolve) => {
      commit('clearData')
      commit('clearQuery')
      commit('clearSelectedInspectionPlan')
      resolve()
    })
  },
  /**
   * データを取得する
   *
   * @return {void}
   */
  async fetchAll({ commit, state }) {
    // パラメーターの値が空の場合は削除する
    Object.keys(state.query).forEach(
      (key) => state.query[key] === '' && delete state.query[key],
    )
    state.query = Object.assign(state.query, {
      inspection_type_id: state.inspection_type.id,
    })
    const response = await api.get('operate/inspection_plan_inspections/', {
      params: state.query,
    })
    commit('setData', response.data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
